import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	sprintDate: {
		id: 'software-burn-reports-common.sprint-details.sprint-date',
		defaultMessage: 'Date',
		description: 'Label for the sprint date',
	},
	screenReaderSprintDate: {
		id: 'software-burn-reports-common.sprint-details.screen-reader-sprint-date',
		defaultMessage: '{startDate} to {endDate}',
		description: 'Screenreader text for the sprint date',
	},
	sprintGoal: {
		id: 'software-burn-reports-common.sprint-details.sprint-goal',
		defaultMessage: 'Sprint goal',
		description: 'Label for the sprint goal',
	},
});

export default messages;
